import biller from "./biller";
import channel from "./channel";

const prtChild = [
    // To be determine if it is on admin or partner profile
    // channel,
    biller
];

export default prtChild;